import React, { Component } from 'react';
import { AddCategoryProps, AddCategoryState } from '../../interfaces/category'
import { connect } from 'react-redux'
import jwt from 'jsonwebtoken'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import { secretKey } from '../../secret'
import { Link, Redirect } from 'react-router-dom';
import config from '../config/setting'
import CheckChanges from '../confirmOnLeave';
import Select from 'react-select'
import { addInventory } from '../../redux/actions/inventory';
import { logoutUser } from './../../redux/actions/user';
import { AddInventoryProps, AddInventoryState } from '../../interfaces/inventory';

class AddInventory extends Component<AddInventoryProps, AddInventoryState> {
    constructor(props: any) {
        super(props);
        this.state = {
            name: "",
            description: "",
            subCategory: [{name: ""}],
            status: "1",
            isActive: "1"
        }
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        // this.props.roleList();
    }
    handleInputChange(event: { target: { name: any; value: any; }; }) {
        if(event.target.value[0]==" "){
        }else{
          this.setState({
              [event.target.name]: event.target.value,
          });
        }
    }

    handleSubCategoryInputChange = (e: any, index: any) => {
        if (e.target) {
            const { name, value } = e.target;
            const list: any = this.state.subCategory;
            list[index][name] = value;
            this.setState({ subCategory: list });
        }
    };

    handleAddSubCategory = (i: any) => {
        const list: any = this.state.subCategory;
        if (list[i]["name"] == "") {
            alert("Please first fill in current fields")
        }
        //  else if (i == '4') {
        //     alert("Sorry you can add only 5 sub categories")
        // }
         else {
            const newlist: any = { name: "" }
            const subCate: any = this.state.subCategory.concat(newlist)
            this.setState({ subCategory: subCate });
        }
    };

    handleRemoveSubCategory = (index: any) => {
        const list = this.state.subCategory;
        list.splice(index, 1);
        this.setState({ subCategory: list });
    };

    isCatReady = () => {
        const { name, description } = this.state
        return (name !== "" && description !== "");
    }

    handleSaveBtnClick = (event: any) => {
        let { name, description, status, subCategory } = this.state;
        let data = {
            name: name,
            description: description,
            status: status,
            // sub cayegory name
            subCategory: JSON.stringify(subCategory)
        }

        console.log("data", data);
        this.props.addInventory(data);
    }
    render() {
        if (sessionStorage.token) {
            jwt.verify(sessionStorage.token, config.secretKey, (err: any, decoded: any) => {
                if (err) {
                    this.props.logoutUser();
                }
            });
        } else {
            return <Redirect to="/" />
        }
        let msg;
        let messcolor;
        // const { isInserted, message, brands, channels, types } = this.props;
        // if (isInserted) {
        //     msg = message;
        //     messcolor = 'green'
        // } else {
        //     msg = message;
        //     messcolor = 'red'
        // }
        const  { subCategory } = this.state;
        console.log("this.props", this.props);

        return (
            <div className="page">
                <CheckChanges path="add-category" />
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        {/* <!-- Page Header--> */}
                        <header className="page-header pb-1">
                            <div className="container-fluid">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h4>Inventory Management</h4>
                                </div>
                            </div>
                        </header>
                        {/*  Breadcrumb */}
                        <div className="breadcrumb-holder container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/inventory" className="text-primary">Inventory</Link></li>
                                <li className="breadcrumb-item active">Add Inventory</li>
                            </ul>
                        </div>
                        <section className="forms">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body pt-xl-0">
                                                <strong><p className="text-center font-weight-light mb-4" style={{ color: messcolor }}>
                                                    {msg}
                                                </p></strong>

                                                <div className="form-horizontal p-xl-4">

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Name<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="name" type="text" name="name" required data-msg="Please enter Store Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Description<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <textarea id="description" name="description" required data-msg="Please enter Description" className="input-material" onChange={this.handleInputChange} ></textarea>
                                                        </div>
                                                    </div>
                                                    {/* sub Categories */}
                                                    {subCategory.map((x: any, i: any) => {
                                                        return (
                                                            <div key={i}>
                                                                <div className="row form-group">
                                                                    <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Sub Inventory<span className="text-danger">*</span></label>
                                                                    <div className="col-md-7 col-sm-7">
                                                                        <input id="name" type="text" name="name" min={5} value={x.name} required placeholder="Sub Inventory Name"  className="input-material" onChange={e => this.handleSubCategoryInputChange(e, i)} />
                                                                    </div>
                                                                    <div className="col-md-2 col-sm-2 mt-3">
                                                                    {subCategory.length !== 1 &&
                                                                        <button className="btn btn-sm btn-outline-danger"
                                                                            onClick={() => this.handleRemoveSubCategory(i)}><i className="fa fa-trash"></i></button>}
                                                                    {subCategory.length - 1 === i && <button className="btn btn-sm btn-primary ml-2" onClick={() => this.handleAddSubCategory(i)}><i className="fa fa-plus"></i></button>}    
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Status<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="status" className="form-control text-capitalize mt-2" required data-msg="Please select status" onChange={this.handleInputChange}>
                                                                <option value={config.ACTIVE}>Active</option>
                                                                <option value={config.INACTIVE}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group float-right mt-3">
                                                    <button className='btn btn-primary' disabled={!this.isCatReady()} onClick={this.handleSaveBtnClick}>Add Category</button>
                                                </div>
                                            </div>
                                        </div >
                                    </div>
                                </div>
                            </div>
                        </section>
                     <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    console.log("state", state);
    return {

    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
      addInventory: function (data: any) {
            dispatch(addInventory(data))
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddInventory);